var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApplicationContext } from "../../../ApplicationContext";
import React from "react";
import { injectIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import { observer } from "mobx-react";
import { Table } from 'reactstrap';
import TableHeaderColumn from "../../components/ui/Table/TableHeaderColumn";
import TableFieldTypeColumn from "../../components/ui/Table/TableFieldTypeColumn";
var ReportTable = /** @class */ (function (_super) {
    __extends(ReportTable, _super);
    /**
     *
     */
    function ReportTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.setTableRef = _this.setTableRef.bind(_this);
        _this.onTableScroll = _this.onTableScroll.bind(_this);
        return _this;
    }
    ReportTable.prototype.componentDidMount = function () {
    };
    ReportTable.prototype.render = function () {
        var _a = this.props, intl = _a.intl, reportDataModel = _a.reportDataModel, reportModel = _a.reportModel;
        var headers = reportDataModel.getHeaders(reportModel.columns);
        var body = reportDataModel.getBody();
        return React.createElement(Row, { className: "report-table-row" },
            React.createElement(Col, { className: "px-0", sm: 12 },
                React.createElement("div", { className: "report-table mt-4" },
                    React.createElement("div", { ref: this.setTableRef, className: "table-container w-100" },
                        React.createElement(Table, { className: "table-sm table-striped mb-5" },
                            React.createElement("thead", null,
                                React.createElement("tr", null, headers.map(function (reportDataHeaderModel, index) {
                                    if (!reportDataHeaderModel.hidden) {
                                        return React.createElement(TableHeaderColumn, { key: reportModel.id + '-th-' + index, labelId: 'reports.table.columns.header.' + reportDataHeaderModel.name, label: reportDataHeaderModel.name });
                                    }
                                    return null;
                                }))),
                            React.createElement("tbody", null, body.map(function (row, index) {
                                return React.createElement("tr", { key: reportModel.id + '-tr-' + index }, row.map(function (columnValue, index) {
                                    if (!headers[index].hidden) {
                                        return React.createElement(TableFieldTypeColumn, { key: reportModel.id + '-td-' + index, type: headers[index].type, value: columnValue });
                                    }
                                    return null;
                                }));
                            })))))));
    };
    /**
     *
     */
    ReportTable.prototype.onTableScroll = function () {
        var _a = this.state, thead = _a.thead, tableContainer = _a.tableContainer;
        thead.style.transform = 'translateY(' + tableContainer.scrollTop + 'px)';
        if (tableContainer.scrollTop < 5 && thead.classList.contains('box-shadow')) {
            thead.classList.remove('box-shadow');
        }
        if (tableContainer.scrollTop > 5 && !thead.classList.contains('box-shadow')) {
            thead.classList.add('box-shadow');
        }
    };
    /**
     *
     * @param ref
     */
    ReportTable.prototype.setTableRef = function (ref) {
        if (ref) {
            var table = ref.querySelector('table');
            var thead = ref.querySelector('thead');
            this.setState({ table: table, thead: thead, tableContainer: ref });
            ref.addEventListener('scroll', this.onTableScroll);
        }
    };
    ReportTable = __decorate([
        observer
    ], ReportTable);
    return ReportTable;
}(React.Component));
ReportTable.contextType = ApplicationContext;
export default injectIntl(ReportTable);
